const PRODUCT_CARD_SECTION_ID = 'main-product-card';
const COLLECTION_EMPTY_STATE_SECTION_ID = 'main-collection-empty-state';
const COLLECTION_CAROUSEL_EMPTY_STATE_SECTION_ID = 'main-collection-carousel-empty-state';
const DEFAULT_PRODUCTS_PAGE_SIZE = window.Grafite?.ResearchVehicle?.defaultProductsPerPage;
const GRAPHQL_COLLECTION_BATCH_SIZE = window.Grafite?.ResearchVehicle?.graphqlCollectionBatchSize;
const GRAPHQL_SEARCH_BATCH_SIZE = window.Grafite?.ResearchVehicle?.graphqlSearchBatchSize;
const OPENSEARCH_URL = window.Grafite?.ResearchVehicle?.openSearchUrl;
const OPENSEARCH_AUTH = window.Grafite?.ResearchVehicle?.openSearchAuth;

const MOUNT_SELECTOR = '[data-vehicle-search-mount]';
const PRODUCT_PER_PAGE_SELECTOR = 'data-products-per-page';
const MAX_PRODUCTS_COUNT_SELECTOR = 'data-max-products-count';

const VEHICLE_SEARCH_STORAGE_KEY = window.Grafite?.ResearchVehicle?.grafiteSelectedVehicleLocalStorageKey;

const GET_SEARCH_PRODUCTS_HANDLE_BY_SKUS = `
  query handleProductsFromSearch($query: String!, $first: Int!, $after: String, $productFilters: [ProductFilter!], $sortKey: SearchSortKeys, $reverse: Boolean) {
    search(query: $query, first: $first, after: $after, productFilters: $productFilters, sortKey: $sortKey, reverse: $reverse, types: [PRODUCT]) {
      edges {
        cursor
        node {
          ... on Product {
            handle
            productType
            variants(first: 250) {
              edges {
                node {
                  sku
                }
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

const GET_PRODUCTS_HANDLE_BY_SKUS = `
  query handleProductsFromCollection($first: Int, $last: Int, $handle: String!, $filters: [ProductFilter!], $after: String, $before: String, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
    collection(handle: $handle) {
      products(first: $first, last: $last, filters: $filters, after: $after, before: $before, sortKey: $sortKey, reverse: $reverse) {
        edges {
          cursor
          node {
            handle
            productType
            variants(first: 250) {
              edges {
                node {
                  sku
                }
              }
            }
          }
        }  
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;

const SORT_KEYS = {
  'manual': 'MANUAL',
  'most-relevant': 'RELEVANCE',
  'best-selling': 'BEST_SELLING',
  'title-ascending': 'TITLE_ASCENDING',
  'title-descending': 'TITLE_DESCENDING',
  'price-ascending': 'PRICE_ASCENDING',
  'price-descending': 'PRICE_DESCENDING',
  'created-ascending': 'CREATED_ASCENDING',
  'created-descending': 'CREATED_DESCENDING',
  'collection-default': 'COLLECTION_DEFAULT',
};

export {
  DEFAULT_PRODUCTS_PAGE_SIZE,
  GRAPHQL_COLLECTION_BATCH_SIZE,
  PRODUCT_CARD_SECTION_ID,
  COLLECTION_EMPTY_STATE_SECTION_ID,
  COLLECTION_CAROUSEL_EMPTY_STATE_SECTION_ID,
  GET_PRODUCTS_HANDLE_BY_SKUS,
  GET_SEARCH_PRODUCTS_HANDLE_BY_SKUS,
  VEHICLE_SEARCH_STORAGE_KEY,
  MOUNT_SELECTOR,
  PRODUCT_PER_PAGE_SELECTOR,
  MAX_PRODUCTS_COUNT_SELECTOR,
  OPENSEARCH_URL,
  OPENSEARCH_AUTH,
  SORT_KEYS,
  GRAPHQL_SEARCH_BATCH_SIZE,
};
